import { render, staticRenderFns } from "./UpdateSynonymModal.vue?vue&type=template&id=e5a19378"
import script from "./UpdateSynonymModal.vue?vue&type=script&lang=js"
export * from "./UpdateSynonymModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateSynonymModal.vue?vue&type=style&index=0&id=e5a19378&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports